import * as yup from "yup";

export const adminSingleOwnerFlagsSchema = yup.object().shape({
  type: yup.string().required("The field is required."),
  content: yup.string().required("The field is required."),
});
